import { useQuery } from '@tanstack/react-query';
import { getApprovalDetails } from '../../api/approvals';
import { useProductSettings } from '@workspace/utils-react';
import type { Settings } from '../../AppContainer';

export const approvalDetailsQueryKey = (reviewId: string) =>
  ['approvalDetails', reviewId] as const;

export function useApprovalDetails(reviewId: string) {
  const { apiUrl } = useProductSettings<Settings>();
  return useQuery({
    queryKey: approvalDetailsQueryKey(reviewId),
    queryFn: () => getApprovalDetails(apiUrl, reviewId),
    enabled: !!reviewId,
  });
}
